import "./style.css";

const Product = ({ product, handleClick }) => {
  return (
    <>
      <div className="productCard" id={product.id}>
        <div className="imageContainer">
          <img src={product.img} alt={product.name} />
        </div>
        <div className="productInfo">
          <p className="productName">{product.name}</p>
          <p className="productCategory">{product.category}</p>
          <p className="productPrice">R$ {product.price.toFixed(2)}</p>
          <button
            onClick={() => {
              handleClick(product.id);
            }}
          >
            Adicionar
          </button>
        </div>
      </div>
    </>
  );
};

export default Product;
